// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */
.Header-headerMenuOffcanvasBackShadow-FI6eH {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
    transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
}
.Header-headerMenuOffcanvasBackShadow-FI6eH.Header-headerMenuBackShadowShow-JWQta {
    opacity: .5;
    visibility: visible;
}
.Header-frontPageHeader-gN054 {
    height: var(--frontPage-header-height);
    padding: 18px 24px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1032;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    background: var(--background-primary);
}
.Header-headerLogoContainer-lI3_W {
    max-width: 130px;
    height: 52px;
    display: inline-block;
}
.Header-headerBrandLogo-pV08L {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: left;
       object-position: left;
    display: inline-block;
}
.Header-headerHamburgBtn-RDXyE {
    display: none;
    outline: unset;
    border: unset;
    background: unset;
    padding: 0;
    width: 30px;
    height: 30px;
}
.Header-homeHeaderCloseBtn-PYRzc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    border: unset;
    background: unset;
    padding: 0;
    width: 100%;
}
.Header-homeHeaderCloseBtn-PYRzc>svg {
    width: 24px;
    height: 24px;
    color: var(--primary-foreground);
}
.Header-headerHamburgBtn-RDXyE:hover,
.Header-headerHamburgBtn-RDXyE:focus,
.Header-homeHeaderCloseBtn-PYRzc:hover,
.Header-homeHeaderCloseBtn-PYRzc:focus {
    outline: unset;
    border: unset;
    background: unset;
}
.Header-headerHamburgBtn-RDXyE>svg {
    width: 100%;
    height: 100%;
    color: var(--primary-foreground);
}
.Header-headerMenuListWrapper-JmF5r {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 24px;
}
.Header-verticalHeaderMenuListWrapper-xXugH {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}
.Header-headerMenuList-oPMaq,
.Header-headerDropDownInnerList-xJ7tP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: var(--primary-foreground);
    padding: 0;
}
.Header-headerMenuList-oPMaq svg,
.Header-headerDropDownInnerList-xJ7tP svg {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}
.Header-headerMenuList-oPMaq:hover,
.Header-headerMenuList-oPMaq:focus {
    color: var(--primary-foreground);
}
.Header-headerDropDownInnerListActive-OYkbx:hover,
.Header-headerDropDownInnerListActive-OYkbx:focus,
.Header-headerDropDownInnerListActive-OYkbx:active,
.Header-headerDropDownInnerListActive-OYkbx {
    color: var(--primary-link-foreground);
}
.Header-homeHeaderBtn-jI5K1 {
    padding: 8px 18px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    border-radius: 100px;
}
.Header-homeHeaderBtn-jI5K1,
.Header-homeHeaderBtn-jI5K1:focus,
.Header-homeHeaderBtn-jI5K1:hover {
    background-color: var(--primary-bg);
    color: var(--common-primary-white-foreground);
    border: unset;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}
.Header-headerNavLogoContainer-SQP9Q {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.Header-headerNavLogoHamburg-ipmhC {
    position: relative;
    width: 20px;
    height: 20px;
}
.Header-headerNavLogoContainer-SQP9Q>img,
.Header-headerNavLogoHamburg-ipmhC>svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    -o-object-fit: cover;
       object-fit: cover;
}
.Header-activeListMenu-NmTBs {
    color: var(--primary-link-foreground) !important;
}
.Header-headerMenuItemIcon-ekSGg {
    width: 18px;
    height: 18px;
}
.Header-headerLogoTextContainer-lD99Q {
    max-width: 200px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}
.Header-headerLogoTextContainer-lD99Q,
.Header-headerLogoTextContainer-lD99Q:hover,
.Header-headerLogoTextContainer-lD99Q:focus {
    color: var(--primary-foreground);
    text-decoration: none;
}
.Header-headerLogoTextContainer-lD99Q>span {
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* header offcanvas */
.Header-mobileViewHeaderMenuOffCanvas-I_DN8 {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1050;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    max-width: var(--sideMenu-width);
    width: 100%;
    background-color: var(--background-primary);
    background-clip: padding-box;
    outline: 0;
    opacity: 0;
    padding: 20px 15px 50px;
    -webkit-transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out,
        -webkit-transform 0.3s ease-in-out;
}
.Header-homeHeaderOffcanvasStart-qP5eL {
    right: 0;
    -webkit-transform: translateX(100%);
        -ms-transform: translateX(100%);
            transform: translateX(100%);
}
.Header-homeHeaderOffcanvasEnd-Y8cEo {
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
}
.Header-mobileViewHeaderMenuOffCanvas-I_DN8.Header-homeHeaderOffcanvasShow-Ed4on {
    -webkit-transform: none;
        -ms-transform: none;
            transform: none;
    opacity: 1;
    -webkit-transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}
@media (min-width:1200px) {
    .Header-headerListWebHidden-vzyqg {
        display: none;
    }
}
@media (max-width:1199px) {
    .Header-headerListMobileHidden-ZYjoT {
        display: none;
    }

    .Header-headerHamburgBtn-RDXyE {
        display: block;
    }

    .Header-headerMenuList-oPMaq,
    .Header-headerMobileListContainer-OU2LV {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,uEAAiE;IAAjE,+DAAiE;AACrE;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,qCAAqC;AACzC;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,wBAAqB;OAArB,qBAAqB;IACrB,qBAAqB;AACzB;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,WAAW;AACf;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AAEA;;;;IAII,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;AAEA;IACI,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;AACd;AAEA;;IAEI,oBAAc;QAAd,cAAc;AAClB;AAEA;;IAEI,gCAAgC;AACpC;AAEA;;;;IAII,qCAAqC;AACzC;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;AAEA;;;IAGI,mCAAmC;IACnC,6CAA6C;IAC7C,aAAa;IACb,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,oBAAiB;OAAjB,iBAAiB;AACrB;AAEA;IACI,gDAAgD;AACpD;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AAEA;IACI,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;AAEA;;;IAGI,gCAAgC;IAChC,qBAAqB;AACzB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,gCAAgC;IAChC,WAAW;IACX,2CAA2C;IAC3C,4BAA4B;IAC5B,UAAU;IACV,UAAU;IACV,uBAAuB;IACvB;0CAC8B;IAD9B;0CAC8B;IAD9B;kCAC8B;IAD9B;;0CAC8B;AAClC;AAEA;IACI,QAAQ;IACR,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;AAEA;IACI,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;AAChC;AAEA;IACI,uBAAe;QAAf,mBAAe;YAAf,eAAe;IACf,UAAU;IACV,oEAAoD;IAApD,4DAAoD;IAApD,oDAAoD;IAApD,wFAAoD;AACxD;AAEA;IACI;QACI,aAAa;IACjB;AACJ;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["/* new */\n.headerMenuOffcanvasBackShadow {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .3s ease-in-out, visibility .3s ease-in-out, ;\n}\n\n.headerMenuOffcanvasBackShadow.headerMenuBackShadowShow {\n    opacity: .5;\n    visibility: visible;\n}\n\n.frontPageHeader {\n    height: var(--frontPage-header-height);\n    padding: 18px 24px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    z-index: 1032;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--background-primary);\n}\n\n.headerLogoContainer {\n    max-width: 130px;\n    height: 52px;\n    display: inline-block;\n}\n\n.headerBrandLogo {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: left;\n    display: inline-block;\n}\n\n.headerHamburgBtn {\n    display: none;\n    outline: unset;\n    border: unset;\n    background: unset;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n}\n\n.homeHeaderCloseBtn {\n    display: flex;\n    justify-content: flex-end;\n    border: unset;\n    background: unset;\n    padding: 0;\n    width: 100%;\n}\n\n.homeHeaderCloseBtn>svg {\n    width: 24px;\n    height: 24px;\n    color: var(--primary-foreground);\n}\n\n.headerHamburgBtn:hover,\n.headerHamburgBtn:focus,\n.homeHeaderCloseBtn:hover,\n.homeHeaderCloseBtn:focus {\n    outline: unset;\n    border: unset;\n    background: unset;\n}\n\n.headerHamburgBtn>svg {\n    width: 100%;\n    height: 100%;\n    color: var(--primary-foreground);\n}\n\n.headerMenuListWrapper {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.verticalHeaderMenuListWrapper {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.headerMenuList,\n.headerDropDownInnerList {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    padding: 0;\n}\n\n.headerMenuList svg,\n.headerDropDownInnerList svg {\n    flex-shrink: 0;\n}\n\n.headerMenuList:hover,\n.headerMenuList:focus {\n    color: var(--primary-foreground);\n}\n\n.headerDropDownInnerListActive:hover,\n.headerDropDownInnerListActive:focus,\n.headerDropDownInnerListActive:active,\n.headerDropDownInnerListActive {\n    color: var(--primary-link-foreground);\n}\n\n.homeHeaderBtn {\n    padding: 8px 18px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    border-radius: 100px;\n}\n\n.homeHeaderBtn,\n.homeHeaderBtn:focus,\n.homeHeaderBtn:hover {\n    background-color: var(--primary-bg);\n    color: var(--common-primary-white-foreground);\n    border: unset;\n    outline: unset;\n    box-shadow: unset;\n}\n\n.headerNavLogoContainer {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.headerNavLogoHamburg {\n    position: relative;\n    width: 20px;\n    height: 20px;\n}\n\n.headerNavLogoContainer>img,\n.headerNavLogoHamburg>svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n    object-fit: cover;\n}\n\n.activeListMenu {\n    color: var(--primary-link-foreground) !important;\n}\n\n.headerMenuItemIcon {\n    width: 18px;\n    height: 18px;\n}\n\n.headerLogoTextContainer {\n    max-width: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.headerLogoTextContainer,\n.headerLogoTextContainer:hover,\n.headerLogoTextContainer:focus {\n    color: var(--primary-foreground);\n    text-decoration: none;\n}\n\n.headerLogoTextContainer>span {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* header offcanvas */\n.mobileViewHeaderMenuOffCanvas {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: 1050;\n    display: flex;\n    flex-direction: column;\n    max-width: var(--sideMenu-width);\n    width: 100%;\n    background-color: var(--background-primary);\n    background-clip: padding-box;\n    outline: 0;\n    opacity: 0;\n    padding: 20px 15px 50px;\n    transition: opacity 0.4s linear 0.3s,\n        transform 0.3s ease-in-out;\n}\n\n.homeHeaderOffcanvasStart {\n    right: 0;\n    transform: translateX(100%);\n}\n\n.homeHeaderOffcanvasEnd {\n    left: 0;\n    transform: translateX(-100%);\n}\n\n.mobileViewHeaderMenuOffCanvas.homeHeaderOffcanvasShow {\n    transform: none;\n    opacity: 1;\n    transition: opacity 0.2s, transform 0.3s ease-in-out;\n}\n\n@media (min-width:1200px) {\n    .headerListWebHidden {\n        display: none;\n    }\n}\n\n@media (max-width:1199px) {\n    .headerListMobileHidden {\n        display: none;\n    }\n\n    .headerHamburgBtn {\n        display: block;\n    }\n\n    .headerMenuList,\n    .headerMobileListContainer {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMenuOffcanvasBackShadow": `Header-headerMenuOffcanvasBackShadow-FI6eH`,
	"headerMenuBackShadowShow": `Header-headerMenuBackShadowShow-JWQta`,
	"frontPageHeader": `Header-frontPageHeader-gN054`,
	"headerLogoContainer": `Header-headerLogoContainer-lI3_W`,
	"headerBrandLogo": `Header-headerBrandLogo-pV08L`,
	"headerHamburgBtn": `Header-headerHamburgBtn-RDXyE`,
	"homeHeaderCloseBtn": `Header-homeHeaderCloseBtn-PYRzc`,
	"headerMenuListWrapper": `Header-headerMenuListWrapper-JmF5r`,
	"verticalHeaderMenuListWrapper": `Header-verticalHeaderMenuListWrapper-xXugH`,
	"headerMenuList": `Header-headerMenuList-oPMaq`,
	"headerDropDownInnerList": `Header-headerDropDownInnerList-xJ7tP`,
	"headerDropDownInnerListActive": `Header-headerDropDownInnerListActive-OYkbx`,
	"homeHeaderBtn": `Header-homeHeaderBtn-jI5K1`,
	"headerNavLogoContainer": `Header-headerNavLogoContainer-SQP9Q`,
	"headerNavLogoHamburg": `Header-headerNavLogoHamburg-ipmhC`,
	"activeListMenu": `Header-activeListMenu-NmTBs`,
	"headerMenuItemIcon": `Header-headerMenuItemIcon-ekSGg`,
	"headerLogoTextContainer": `Header-headerLogoTextContainer-lD99Q`,
	"mobileViewHeaderMenuOffCanvas": `Header-mobileViewHeaderMenuOffCanvas-I_DN8`,
	"homeHeaderOffcanvasStart": `Header-homeHeaderOffcanvasStart-qP5eL`,
	"homeHeaderOffcanvasEnd": `Header-homeHeaderOffcanvasEnd-Y8cEo`,
	"homeHeaderOffcanvasShow": `Header-homeHeaderOffcanvasShow-Ed4on`,
	"headerListWebHidden": `Header-headerListWebHidden-vzyqg`,
	"headerListMobileHidden": `Header-headerListMobileHidden-ZYjoT`,
	"headerMobileListContainer": `Header-headerMobileListContainer-OU2LV`
};
module.exports = ___CSS_LOADER_EXPORT___;
